import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-drag-handle.tsx
/**
* icon.16.drag-handle
*
* Keywords: menu, hamburger, list, navigation, horizontal, lines, stacked, three
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTEgMTEuNWEuNS41IDAgMCAxLS41LjVoLTVhLjUuNSAwIDAgMSAwLTFoNWEuNS41IDAgMCAxIC41LjVNMTEgOGEuNS41IDAgMCAxLS41LjVoLTVhLjUuNSAwIDAgMSAwLTFoNWEuNS41IDAgMCAxIC41LjVtMC0zLjVhLjUuNSAwIDAgMS0uNS41aC01YS41LjUgMCAwIDEgMC0xaDVhLjUuNSAwIDAgMSAuNS41IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-11886
*/
const Icon16DragHandle = memo(function Icon16DragHandle(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color-2, var(--color-icon-secondary))",
			fillRule: "evenodd",
			d: "M11 11.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5M11 8a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5m0-3.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5",
			clipRule: "evenodd"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color-2, var(--color-icon-secondary))",
			fillRule: "evenodd",
			d: "M11 10.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5m0-3a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5m0-3a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon16DragHandle };

//# sourceMappingURL=icon-16-drag-handle.js.map